import { TasksFilter } from '@AMIEWEB/GlobalSearch/Tasks/FilterUtils';

/**
 * Placement Modifications link-task search filters.
 * Same behavior as global {@link TasksFilter} with `modsLink` variant (typeahead facility, sorted categories).
 */
export class ModsLinkTasksFilter extends TasksFilter {
  constructor(t: (key: string) => string) {
    super({}, t, {}, {}, 'modsLink');
  }
}
